import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var ElectricalEng = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.904 11.681h-3.687V6.996a.893.893 0 0 0-.896-.897.893.893 0 0 0-.897.897v4.685h-3.089V6.996a.893.893 0 0 0-.897-.897.893.893 0 0 0-.896.897v4.685h-3.687a.893.893 0 0 0-.897.897v5.981c0 .499.399.897.897.897h2.192l.797 3.49c.1.398.498.697.897.697h2.292v6.28c0 3.588-2.89 6.48-6.477 6.48a6.465 6.465 0 0 1-6.476-6.48v-15.95A8.251 8.251 0 0 0 13.81 5.7a8.251 8.251 0 0 0-8.27 8.274v3.788c0 .498.398.897.896.897a.893.893 0 0 0 .897-.897v-3.788c0-3.589 2.89-6.48 6.477-6.48a6.465 6.465 0 0 1 6.476 6.48v15.949c0 4.585 3.687 8.373 8.37 8.373 4.583 0 8.27-3.688 8.27-8.373v-6.18h2.291a.957.957 0 0 0 .897-.698l.797-3.489h2.192a.893.893 0 0 0 .897-.897v-5.981c-.2-.498-.598-.997-1.096-.997Zm-.897 5.981h-1.992c-.4 0-.798.3-.897.698l-.797 3.489h-4.982l-.797-3.49a.957.957 0 0 0-.897-.697h-1.993v-4.087h12.256v4.087h.1Z"
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.621 18.16c.399.2.598.599.399.997l-1.893 7.277h2.391c.398 0 .697.2.797.598.1.3.1.698-.2.997L2.85 37.997c-.298.3-.697.399-1.096.2-.398-.2-.498-.599-.398-.997l1.993-7.277H.857c-.399 0-.698-.2-.797-.598-.1-.3-.1-.698.199-.997L9.625 18.26c.2-.299.697-.299.996-.1ZM2.95 28.03h1.495c.299 0 .598.1.697.399.2.199.2.498.2.797L4.044 34.01l5.38-5.782H7.932c-.299 0-.598-.1-.697-.398-.2-.2-.2-.499-.2-.798l1.296-4.884-5.38 5.88Z"
  }));
});
ElectricalEng.displayName = 'ElectricalEng';
ElectricalEng.defaultProps = {
  'aria-label': 'ElectricalEng'
};
export default ElectricalEng;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Subject/ElectricalEng.js
// module id = 3635
// module chunks = 11